import { StylesConfig } from 'react-select';

export interface CreatableOption {
    value: string;
    label: string;
}

/** Shared react-select styles for subject names, section tags, etc. */
export const creatableMultiSelectStyles = (
    isSmall = false,
): StylesConfig<CreatableOption, true> => ({
    control: (base, state) => ({
        ...base,
        borderRadius: 8,
        borderColor: state.isFocused ? '#2684FF' : '#1C0054',
        boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : 'none',
        minHeight: isSmall ? 36 : 45,
        fontSize: isSmall ? 13 : 15,
        '&:hover': {
            borderColor: state.isFocused ? '#2684FF' : '#1C0054',
        },
    }),
    multiValue: (base) => ({
        ...base,
        backgroundColor: '#F1E9FF',
        color: '#1C0054',
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isFocused ? '#DEEBFF' : base.backgroundColor,
        color: '#1C0054',
    }),
});
